import {PropertiesPane} from '../components/NodePropertiesPane.jsx'
import Text from '../../SidePanel/RightPanel/PropertiesControllerText.jsx'
import ButtonDownload from '../components/PropertiesPaneButtonDownload.jsx'
import ButtonPasteUpload from './PropertiesPaneButtonPasteUpload.jsx'
import ButtonUpload from './PropertiesPaneButtonUpload.jsx'
import Thumb from './PropertiesControllerThumb.jsx'
import Model from './ModelPic.mjs'

const PropertiesPanePic = (props) => (
    <PropertiesPane
        buttons={
            <>
                <ButtonDownload />
                <ButtonUpload />
                <ButtonPasteUpload />
            </>
        }

        controllers={
            <>
                <Text prop="text" />
                <Thumb />
            </>
        }

        Model={Model}
        {...props}
    />
)

export default PropertiesPanePic
